import { Code, ConnectError, createClient, Interceptor } from '@connectrpc/connect';
import { createConnectTransport } from '@connectrpc/connect-web';
import { GatewayServices } from '../gen/proto/api/gateway/v1/gateway_pb';
import useAuthStore from '../stores/auth.store';
import { authApi } from './auth.api';

const authInterceptor: Interceptor = (next) => async (req) => {

  const token = useAuthStore.getState().authToken;
  if (token) {
    req.header.set('Authorization', `Bearer ${token}`);
  }

  try {
    return await next(req);
  } catch (error) {
    if (error instanceof ConnectError && error.code === Code.Unauthenticated) {
      const refreshedToken = await authApi.refreshToken();
      if (refreshedToken) {
        req.header.set('Authorization', `Bearer ${refreshedToken}`);
        return await next(req);
      }

      // If token refresh fails, clear auth state and redirect to login
      await useAuthStore.getState().logout();
      window.location.href = '/login';
    }

    throw error;
  }
};

const transport = createConnectTransport({
  baseUrl:  process.env.REACT_APP_API_URL || 'http://localhost:8080',
  interceptors: [authInterceptor],
});

export const gatewayClient = createClient(GatewayServices, transport);
